import React from "react";
import MapPin from "@assets/MapPin.svg"

const MapIcon = ({dealer, index, quantity, hover, open, onClick, compact}) => {
  const showClusterCount = true

  return (
    <div className={`ft_dealer-locator__map__item ${hover ? 'hover' : ''} ${open ? 'open' : ''} ${dealer.preferred_dealer ? 'ft_dealer-locator__map__item--preferred' : '' } ${dealer.specialty_retail_dealer ? 'ft_dealer-locator__map__item--specialty' : '' }`} onClick={onClick}>
      {quantity == 1 || !showClusterCount ? <MapPin /> :
        [<MapPin />,
        <div className="ft_dealer-locator__map__item_index ft_dealer-locator__map__item_index--cluster">
          {"x" + quantity}
        </div>]
      }
    </div>
  );

}

export default MapIcon;
